import React, { useEffect, useState } from "react";
import { Button, DatePicker, Form, Input, InputNumber, Select } from "antd";
import { findTeamByValue, getTeamAreas } from "../../../types/initStore/initUser";
import { isAfterToDay, toDay } from "../../../helpers/dayjsHelper";
import { MessageAnt } from "../../../redux/slices/ui/uiAction";
import { MessageType } from "../../../types/messageType";
import dayjs from "dayjs";
import { typeForDetailsProyect } from "../../../types/typeModalDetailsProject";
import { ContainerModal } from "../../container/ContainerModal";

const initForm = {
    hours: 0,
    createdAt: "",
    periodOfWork: "",
    comment: "",
    area: [],
    email: [],
};

const allAreaTeam = getTeamAreas(["responsible", "comercial", "leader", "planning"]);

const dateFormat = "YYYY/MM/DD";

export const FormExtraTime = ({ type = 0, dataForm = {}, users = [], title = "", editFormForProjectDetails, closeModalDetails }) => {

    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);

    const [userOptionSelect, setUserOptionSelect] = useState([]);

    useEffect(() => {
        if (type === 0) {
            form.setFieldsValue(initForm);
        } else {
            const { createdAt, ...restData } = dataForm;
            setUsersByArea(users, restData.area);
            form.setFieldsValue({ ...restData, createdAt: dayjs(createdAt, dateFormat) });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setUsersByArea = (allUser = [], value = "") => {
        const teamKey = findTeamByValue(value)
        if (!teamKey) return

        const [key] = teamKey
        const newUsers = allUser[key]
            .filter(({ isActive }) => {
                return isActive
            })

        setUserOptionSelect(newUsers);
        form.setFieldsValue({ email: [] });
    };

    const finishForm = async (values) => {
        setLoading(true);
        const { createdAt, email, ...formData } = values;

        const today = toDay().dayFormat;
        const isAfterToday = isAfterToDay(createdAt.format("YYYY-MM-DD"), today);
        if (isAfterToday) {
            MessageAnt(MessageType.warning, "La fecha selecciona pasa del dia de hoy");
            return;
        }

        formData.createdAt = createdAt.format("YYYY-MM-DD");

        const allArrays = Object.values(users).flat();
        const findEmail = allArrays.find(({ name }) => name === email);

        await editFormForProjectDetails(typeForDetailsProyect.hrsExtraTime, {
            typeEndpointHrsExtra: type,
            idTimeExtra: dataForm?.key ?? null,
            email: findEmail ? findEmail.email : "",
            ...formData,
        });

        setLoading(false);
    };
    return (
        <div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
            <ContainerModal
                title={title}
                actionButton={() => {
                    closeModalDetails();
                }}
                className={"w-[500px]"}
            >
                <Form
                    form={form}
                    onFinish={finishForm}
                    layout="vertical"
                    className="w-full flex flex-col"
                    onValuesChange={(changedValues, allValues) => {
                        const key = Object.keys(changedValues)[0];
                        const value = Object.values(changedValues)[0];
                        if (key === "area") {
                            setUsersByArea(users, value);
                        }
                    }}
                >
                    <div className="grid grid-cols-[25%_33%_33%] gap-2">
                        <Form.Item
                            name={"hours"}
                            label={"Tiempo Hrs"}
                            rules={[
                                {
                                    type: "number",
                                    min: 1,
                                    message: "El numero no tiene que ser cero",
                                },
                                {
                                    required: true,
                                    message: "Necesita mayor a cero",
                                },
                            ]}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                        <Form.Item
                            name={"createdAt"}
                            label={"Fecha de creación"}
                            rules={[
                                {
                                    required: true,
                                    message: "Por favor necesita una fecha!",
                                },
                            ]}
                            className="w-full"
                        >
                            <DatePicker className="w-full" />
                        </Form.Item>
                        <Form.Item name={"periodOfWork"} label={"Periodo de trabajo"}>
                            <Input placeholder="Periodo" />
                        </Form.Item>
                    </div>
                    <Form.Item name="comment" label="Comentario" className="h-[140px]">
                        <Input.TextArea
                            placeholder="Comentario"
                            autoSize={{
                                minRows: 5,
                                maxRows: 5,
                            }}
                            showCount={false}
                        />
                    </Form.Item>
                    <Form.Item
                        name={"area"}
                        label={"Area"}
                        rules={[
                            {
                                required: true,
                                message: "Por favor necesita una area!",
                            },
                        ]}
                    >
                        <Select placeholder={"Area"}>
                            {allAreaTeam.map((area, index) => (
                                <Select.Option key={`${index}-areaTime`} value={area}>
                                    {area}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name={"email"}
                        label={"Usuario"}
                        rules={[
                            {
                                required: true,
                                message: "Por favor necesita un usuario!",
                            },
                        ]}
                    >
                        <Select placeholder={"Usuario"} disabled={userOptionSelect.length === 0}>
                            {userOptionSelect.map((userData, index) => {
                                return (
                                    <Select.Option key={`${index}-userteam`} value={userData.name}>
                                        {userData.name}
                                    </Select.Option>
                                );
                            })}
                        </Select>
                    </Form.Item>
                    <div className="w-full h-[40px] mt-4 overflow-hidden flex justify-end gap-4">
                        <Button htmlType="button" onClick={closeModalDetails}>
                            Cancelar
                        </Button>
                        <Button type="primary" htmlType="submit" className="bg-primaryTwo" loading={loading}>
                            Guardar
                        </Button>
                    </div>
                </Form>
            </ContainerModal>
        </div>
    );
};
